import React, { Component, CSSProperties } from 'react';

import Modal from 'components/Modal';

import PurchaseDefault from './PurchaseDefault';
import PurchaseFace from './PurchaseFace';
import PurchaseName from './PurchaseName';

export default class PurchaseModalContainer extends Component<Props> {
  renderContents = () => {
    const { data: { action } } = this.props;
    switch (action) {
      case 'AskNameChange':
        return <PurchaseName {...this.props} />;
      case 'FaceChange':
        return <PurchaseFace {...this.props} />;
      default:
        return <PurchaseDefault {...this.props} />;
    }
  };

  render = () => {
    const {
      className,
      disableTouchEvents,
      isOpen,
      onRequestClose,
      overlayClassName,
      style,
    } = this.props;
    return (
      <Modal
        className={className}
        disableTouchEvents={disableTouchEvents}
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        overlayClassName={overlayClassName}
        style={style}
      >
        {this.renderContents()}
      </Modal>
    );
  }
}

interface Props {
  className?: string,
  data: any,
  disableTouchEvents?: boolean,
  isOpen: boolean,
  onRequestClose: (...args: any) => any,
  overlayClassName?: string,
  style?: {
    overlay?: CSSProperties,
    content?: CSSProperties,
  },
}
